const _3M_PRINTERS = {
  models: ['3UC58D'],
  entryId: 'blt17852eefeb567454'
};

const TACCOLA_FB_PRINTERS = {
  models: ['25R66A'],
  entryId: 'bltbff2a91204f4f7b1'
};

const TACCOLA_ADF_PRINTERS = {
  models: ['4WS37B'],
  entryId: 'bltfc1debe2f44be33d'
};

const VASARI_FB_PRINTERS = {
  models: ['5SE22B'],
  entryId: 'bltc834475d35549749'
};

const VASARI_ADF_PRINTERS = {
  models: ['6WD15A'],
  entryId: 'blte244c749a6e94457'
};

const SKYREACH_FB_PRINTERS = {
  models: ['6GX04A'],
  entryId: 'blte371deb4f601da7e'
};

// SUNSPEAR DW
const SKYLINE_SUNSPEAR_FB_PRINTERS = {
  models: ['B0YZ2A', 'B0ZA3A', 'B0YZ6A'],
  entryId: 'bltaf036e22fa5dbfc9'
};

// SUNSPEAR SDW
const SKYLINE_SUNSPEAR_ADF_PRINTERS = {
  models: [
    'B0YZ3A',
    'B0ZA6A',
    'B0ZA7A',
    'B0YZ1A',
    'B0YZ5A',
    'B0YZ9A',
    'B0ZA1A'
  ],
  entryId: 'blt515a7f75828befe2'
};

// GREENFIELD DW
const SKYLINE_GREENFIELD_SF_WL_PRINTERS = {
  models: ['B0YW9A', 'B0YX2A', 'B0YX0A', 'B0YW7A'],
  entryId: 'bltc83c6075d8b4b15e'
};

const SKYREACH_ADF_PRINTERS = {
  models: ['6GX05A'],
  entryId: 'blt6f725c20afa36a3f'
};

const EYRIE_PRINTERS = {
  models: ['6GW64A'],
  entryId: 'bltd1d400899c00ee51'
};

const BEAM_PRINTERS = {
  models: ['2Y9H0A'],
  entryId: 'blt943033e3c848127b'
};

const JUPITER_PRINTERS = {
  models: ['7QR88A'],
  entryId: 'blt7758a18f4171b9c5'
};

const BEAM_MFP_PRINTERS = {
  models: ['2Y9H2A'],
  entryId: 'bltaa8e0ea01053683f'
};

const PIXIU_PRINTERS = {
  models: ['2Y9H4A'],
  entryId: 'bltbc6e5d0e142c685a'
};

const TASSEL_PLUS_PRINTERS = {
  models: ['60K57D', '6W7F0A'],
  entryId: 'blt45ac0d7a266098c5'
};

const LEBI_SF_PRINTERS = {
  models: ['3D4L3A', '4A8H8A', '4A8J0A'],
  entryId: 'blt17fde78db8ca8786'
};

const LEBI_WL_PRINTERS = {
  models: [
    '9B2D9A',
    '9B2E0A',
    '5D1B7A',
    '5D1B8A',
    '9B2D3A',
    '9B2D4A',
    '9B2D7A',
    '5D1A8A',
    '9B2C5A',
    '9B2D1A',
    '5D1B9A',
    'D06BKA',
    'D06BLA',
    '9B2C6A',
    '9B2C7A'
  ],
  entryId: 'blt8f077a041a1bbc0d'
};

const MARCONI_PRINTERS = {
  models: [
    '403X0A',
    'C2VZ0A',
    'C2VZ1A',
    'C2VZ2A',
    'C2VZ3B',
    'C2VZ4B',
    'C2VZ5B',
    'C2VZ6B',
    'C2VZ7B',
    'C2WM0A',
    'C2WM1B',
    'C2WM2B',
    'C2WM3B'
  ],
  entryId: 'blt4b75cdb0264940ef'
};

const MORETO_PRINTERS = {
  models: [
    '405W1C',
    'C2VJ4A',
    'C2VJ5A',
    'C2VJ6A',
    'C2VJ9B',
    'C2VJ7B',
    'C2VJ8B',
    'C2VK0B',
    'C2VK1A',
    'C2VK2A',
    'C2VK3A',
    'C2VK5B',
    'C2VK6B',
    'C2VK7B',
    'C2VK8B',
    '405U6A'
  ],
  entryId: 'bltf3cc542b93d0d966'
};

const VICTORIA_PRINTERS = {
  models: [
    '714L5A',
    'C2WR7A',
    'C2WR8A',
    'C2WR9A',
    'C2WS0B',
    'C2WS1B',
    'C2WS2B',
    'C2WS3B',
    'C2WS4B',
    'C2WS5A',
    'C2WS6A',
    'C2XR6A',
    'C2XR7A',
    'C2XR8A',
    'C2XR9B',
    'C2XS0B',
    'C2XS1B',
    'C2XS2A',
    'C2XS3A'
  ],
  entryId: 'blt6bdd7b023a55923b'
};

// Elion, Eddington
const KEBIN_PRINTERS = {
  models: [
    '537P6A',
    '53N95A',
    'C2WH0A',
    'C2WH0B',
    'C2XF9A',
    'C2XF9B',
    'C2WH2B',
    'C2XG1B'
  ],
  entryId: 'blt0be4b42bfa2e4fc8'
};

const DRAGONFLY_BASE_PRINTERS = {
  models: ['53X74A'],
  entryId: 'blt292fb20f6c07844a'
};

const DRAGONFLY_WL_PRINTERS = {
  models: ['53X75A'],
  entryId: 'blt2447ecc7a8f76ffe'
};

const DRAGONFLY_ADF_PRINTERS = {
  models: ['53X76A'],
  entryId: 'bltcbf96840ea259209'
};

const TASSEL_BASE_PRINTERS = {
  models: ['51P94A'],
  entryId: 'bltb34e4a1771e054f8'
};

const TRILLIUM_PRINTERS = {
  models: [
    'A24JGA',
    'AJ4Y5A',
    'AJ4Y4A',
    'A24J2C',
    'B18K0C',
    'B3ZG8C',
    'A24J6B',
    'A24J8B',
    'A24JCB',
    'A24JFB',
    '399P2B',
    'AJ4X0B',
    'A24J7B',
    'AJ4W4B',
    'A24HFA',
    'A24HGA',
    'A24HHA',
    'A24HJA',
    'A24HKA',
    '89F97B',
    '89F98B',
    'A24J4B',
    'A24HWB',
    '89F99B',
    'A24HVB',
    '38Q66C',
    '399P0C',
    '4D047C',
    '89F86C',
    '89F87C',
    '89G03C',
    'A24HXC',
    'A24HYC',
    'A24J1C',
    'AJ4V7C',
    'A24JJC',
    'AJ4V8C',
    'AJ4W3C',
    '89F94A',
    'AJ4X1A',
    '89F88A',
    '89F89A',
    '89F91A',
    '89F93A',
    'AJ4V9A',
    'AJ4W1A',
    'AJ4W2A',
    'AJ4X2A',
    '89F95A',
    'A24J9A',
    'AJ4X3A',
    'B3ZF5A',
    'B18JWA',
    'B18JXA',
    'B3ZH3A',
    'B3ZJ0C'
  ],
  entryId: 'blt845401b5fd66bc44'
};

const TRILLIUM_PLUS_PRINTERS = {
  models: [
    'B3ZF3A',
    'A24HSA',
    'A24HTA',
    'AJ4Y0A',
    'A24JKB',
    'A24HPB',
    'A24HMB',
    'A24HNB',
    'AJ4X9B',
    'A24JLC',
    'AJ4X7C',
    '399P1A',
    '89G05C',
    'AJ4W7B',
    'AJ4W8B',
    'AJ4W9B',
    'B3ZF6A'
  ],
  entryId: 'blt92e49bab78558eab'
};

const SELENE_PRINTERS = {
  models: [
    '4RA80A',
    '4RA81A',
    '4RA82A',
    '4RA83A',
    '4RA84A',
    '5HH64A',
    '5HH65A',
    '5HH66A',
    '5HH67A',
    '5HH68A',
    '5HH69A',
    '5HH70A',
    '5HH71A',
    '5HH72A',
    '5HH73A',
    '5HH74A',
    '5HH75A',
    '5HH76A'
  ],
  entryId: 'blt8eba40fe95941ea0'
};

const HULK_PRINTERS = {
  models: [
    '3G627A',
    '3G628A',
    '3G629A',
    '3G630A',
    '3G631A',
    '3G632A',
    '3G633A',
    '3G634A',
    '3G635A',
    '3G636A',
    '3G637A',
    '3G638A',
    '3G639A',
    '3G640A',
    '3G641A',
    '3G642A',
    '3G643A',
    '3G644A',
    '3G645A',
    '3G646A',
    '3G647A',
    '3G648A',
    '3H670A',
    '3H671A',
    '3H672A',
    '3H673A',
    '9D2X4A',
    '3G646A',
    '3G638A'
  ],
  entryId: 'blt8eba40fe95941ea0'
};

const LOCHSA_PRINTERS = {
  models: [
    '2Z618A',
    '2Z619A',
    '2Z620A',
    '2Z622A',
    '2Z623A',
    '2Z624A',
    '2Z625A',
    '2Z627A',
    '2Z628A',
    '2Z629A',
    '2Z630A',
    '2Z632A',
    '2Z633A',
    '2Z634A',
    '2Z635A',
    '2Z636A'
  ],
  entryId: 'blt8eba40fe95941ea0'
};

const LOTUS_PRINTERS = {
  models: [
    '8X3F4A',
    '8X3F0A',
    '8X3F2A',
    '8X3F6A',
    '8X3F8A',
    '8X3G0A',
    '8X3G4A',
    '8X3G5A',
    '8X3G6A',
    'B09S0A',
    'B09RYA',
    'B09RZA'
  ],
  entryId: 'blt04c822915a662ed4'
};

const CHERRY_2_4_PRINTERS = {
  models: ['8X3D6A', '8X3E0A', '8X3E7A'],
  entryId: 'blt04c822915a662ed4'
};

const ULYSSES_PRINTERS = {
  models: [
    '4RA85A',
    '4RA86A',
    '4RA87A',
    '4RA88A',
    '4RA89A',
    '5HH48A',
    '5HH49A',
    '5HH50A',
    '5HH51A',
    '5HH52A',
    '5HH53A',
    '5HH54A'
  ],
  entryId: 'blt31ac02e29d03268b'
};

// (FLOWERS)
const CHERRY_2_0_PRINTERS = {
  models: [
    '8X3D2A',
    '8X3D4A',
    '8X3D8A',
    '8X3E1A',
    '8X3E2A',
    '8X3E6A',
    '8X3E8A'
  ],
  entryId: 'bltbe7580e43fcd2a0b'
};

const EUTHENIA_PRINTERS = {
  models: [
    '499M7A',
    '499Q8A',
    '74T92A',
    '499Q5A',
    '74P27A',
    '499M8A',
    '759V2A',
    '499Q6A',
    '499M6A',
    '74P26A',
    '499Q3A',
    '759V1A',
    '499Q4A',
    '74P28A',
    '499Q7A',
    '759V0A',
    'D2KG7F',
    'D2KG8F',
    'D2KG9F',
    'D2KG4F'
  ],
  entryId: 'bltf954640540435a09'
};

const ZELUS_PRINTERS = {
  models: [
    '499Q9A',
    '499R0A',
    '499N4A',
    '74P25A',
    'D2KG5F',
    'D2KG6F',
    'D2KG3F'
  ],
  entryId: 'blt2f6af9ac3272189d'
};

const YOSHINO_PRINTERS = {
  models: [
    '2Z599A',
    '2Z600A',
    '2Z601A',
    '2Z602A',
    '2Z604A',
    '2Z605A',
    '2Z606A',
    '2Z607A',
    '2Z609A',
    '2Z610A',
    '2Z611A',
    '2Z612A',
    '2Z613A',
    '2Z614A',
    '2Z615A'
  ],
  entryId: 'blt3f55ccc8dafdf990'
};

const STORM_PRINTERS = {
  models: [
    '3G649A',
    '3G650A',
    '3G651A',
    '3G652A',
    '3G653A',
    '3G654A',
    '3G655A',
    '3G656A',
    '3G657A',
    '3G658A',
    '3G659A',
    '3G660A',
    '3G661A',
    '3G662A',
    '3H667A',
    '3H668A'
  ],
  entryId: 'blt3f55ccc8dafdf990'
};

const NARITA_FB_PRINTERS = {
  models: [
    'B63JSA',
    'B63JTA',
    'B63JVB',
    'B63JWD',
    'B63JXD',
    'B63JYD',
    'B63JZA',
    'B63K0B',
    'B63K1A',
    'B6JW3B',
    'B6JW4D',
    'B6JW5D',
    'B6JW6D'
  ],
  entryId: 'blt2e4388e66c561112'
};

const NARITA_ADF_PRINTERS = {
  models: [
    'B63K3A',
    'B63K4A',
    'B63K5B',
    'B63K6D',
    'B63K7D',
    'B63K8D',
    'B63K9B',
    'B6JX3B',
    'B6JX4D',
    'B6JX5D',
    'B6JX6D'
  ],
  entryId: 'blt7c4f1c61437f94b7'
};

const LEO_WL_PRINTERS = {
  models: [
    // HP Smart Tank 480 series
    'AM9S9A',
    'AM9T0A',
    'AM9T1A',
    'AM9T2A',
    'AM9T3A',
    'AM9T5A',
    'AM9T6A',
    'AM9T7A',
    'AM9T8A',
    // HP Smart Tank 4800 series
    'BE2C0A',
    'BE2C2A',
    'BE2C5A',
    'BE2C6A',
    'BE2C7A',
    'BE2E2A',
    // HP Smart Tank 490 series
    'BE2A2A',
    'BE2A3A',
    'BE2A5A',
    'BE2A6A',
    'BE2A7A',
    'BE2E0A',
    'C30RHA',
    'C30RKA',
    'C30RLA',
    'C30RQA',
    // HP Smart Tank 4900 series
    'BE2D0A',
    'BE2D1A',
    'BE2D2A',
    'BE2D3A',
    'BE2E5A',
    // HP Smart Tank 560 series
    'BE2B0A',
    'BE2B1A',
    'BE2B2A',
    'BE2B3A',
    'BE2B4A',
    'BE2B5A',
    'BE2B6A',
    'BE2B8A',
    // HP Smart Tank 4900 series (LEO PaaS)
    'BE2D7A'
  ],
  entryId: 'blt6369f1385c62f185'
};

const LEO_SF_PRINTERS = {
  models: [
    // HP Smart Tank 180 series
    'C5JN0A',
    'C5JN3A',
    'C5JN4A',
    'C5JN5A',
    'C5JN6A',
    'C5JN8A',
    // HP Smart Tank 190 series
    'C5JM4A',
    'C5JM5A',
    'C5JM7A',
    'C5JP0A',
    'C5JP1A',
    'CA7Q7A',
    'CA7Q8A',
    'CA7R0A'
  ],
  entryId: 'blt0a8d40e7b06b7296'
};

export const SUPPORTED_PRINTERS = [
  _3M_PRINTERS,
  TACCOLA_FB_PRINTERS,
  TACCOLA_ADF_PRINTERS,
  VASARI_FB_PRINTERS,
  VASARI_ADF_PRINTERS,
  SKYREACH_FB_PRINTERS,
  SKYLINE_SUNSPEAR_FB_PRINTERS,
  SKYLINE_SUNSPEAR_ADF_PRINTERS,
  SKYLINE_GREENFIELD_SF_WL_PRINTERS,
  SKYREACH_ADF_PRINTERS,
  EYRIE_PRINTERS,
  BEAM_PRINTERS,
  JUPITER_PRINTERS,
  BEAM_MFP_PRINTERS,
  PIXIU_PRINTERS,
  TASSEL_PLUS_PRINTERS,
  LEBI_SF_PRINTERS,
  LEBI_WL_PRINTERS,
  MARCONI_PRINTERS,
  MORETO_PRINTERS,
  VICTORIA_PRINTERS,
  KEBIN_PRINTERS,
  DRAGONFLY_BASE_PRINTERS,
  DRAGONFLY_WL_PRINTERS,
  DRAGONFLY_ADF_PRINTERS,
  TASSEL_BASE_PRINTERS,
  TRILLIUM_PRINTERS,
  TRILLIUM_PLUS_PRINTERS,
  SELENE_PRINTERS,
  HULK_PRINTERS,
  LOCHSA_PRINTERS,
  LOTUS_PRINTERS,
  CHERRY_2_4_PRINTERS,
  ULYSSES_PRINTERS,
  CHERRY_2_0_PRINTERS,
  EUTHENIA_PRINTERS,
  ZELUS_PRINTERS,
  YOSHINO_PRINTERS,
  STORM_PRINTERS,
  NARITA_FB_PRINTERS,
  NARITA_ADF_PRINTERS,
  LEO_WL_PRINTERS,
  LEO_SF_PRINTERS
];
